export default function format(value) {
  if (!value || value.length !== 10) {
    return value;
  }

  return value.replace(/([\d]{6})([\d]{4})/, '$1-$2');
}
